import React from 'react';
import classnames from 'classnames';
import { BiDataHook } from '@wix/da-bi/pkg/constants';
import TextRenderer from '../TextRenderer';
import CommentViewer from '../DaEditorWrapper/Viewer/Comment';
import SpamView from '../Comment/commonSkeletonViews/SpamView';
import CommentSkeleton from '../Comment/lego/CommentSkeleton';
import HiddenView from '../Comment/commonSkeletonViews/HiddenView';
import CommentCoreBadgeList from '../coreBadge/CoreBadgeList/presets/CommentCoreBadgeList';
import s from './CommentBody.scss';
/** @deprecated */ const CommentBody = ({ comment, className, bodyClassName })=>{
    const { textContent, commentId } = comment;
    return /*#__PURE__*/ React.createElement(CommentSkeleton, {
        className: className,
        comment: comment,
        editingView: null,
        spamView: /*#__PURE__*/ React.createElement(SpamView, null),
        hiddenView: /*#__PURE__*/ React.createElement(HiddenView, null),
        readView: /*#__PURE__*/ React.createElement(React.Fragment, null, !!textContent && /*#__PURE__*/ React.createElement("div", {
            className: s['comment-body-wrap'],
            "data-hook": BiDataHook.COMMENT_BODY
        }, /*#__PURE__*/ React.createElement(TextRenderer, {
            textContent: textContent,
            reactViewer: CommentViewer,
            className: classnames(s['comment'], bodyClassName),
            legacyTheme: 'comments',
            viewerKey: commentId
        })), comment.awardedBadges && /*#__PURE__*/ React.createElement(CommentCoreBadgeList, {
            comment: comment
        }))
    });
};
CommentBody.displayName = 'CommentBody';
export default CommentBody;
